import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from 'src/util/axios-instance';
import {
  DeleteDynamicLinkRequestParams,
  DeleteDynamicLinkResponseData
} from './interfaces/deleteDynamicLink.interface';

export const deleteDynamicLink = async (
  params: DeleteDynamicLinkRequestParams
): Promise<DeleteDynamicLinkResponseData | undefined> => {
  const { dynamicLinkId, projectId } = params;

  const response = await api.delete<DeleteDynamicLinkResponseData>(
    `${API_URL}/v1/project/${projectId}/dynamicLinks/${dynamicLinkId}`,
    { headers: { 'x-session-id': getCachedSessionId() } }
  );

  return response.data;
};
